import { render, staticRenderFns } from "./AddUserToStorageModal.vue?vue&type=template&id=5d08ed27&scoped=true"
import script from "./AddUserToStorageModal.vue?vue&type=script&lang=js"
export * from "./AddUserToStorageModal.vue?vue&type=script&lang=js"
import style0 from "./AddUserToStorageModal.vue?vue&type=style&index=0&id=5d08ed27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d08ed27",
  null
  
)

export default component.exports